import { render, staticRenderFns } from "./prijave-kvarova.editor.vue?vue&type=template&id=9e466c7c&scoped=true&"
import script from "./prijave-kvarova.editor.vue?vue&type=script&lang=ts&"
export * from "./prijave-kvarova.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e466c7c",
  null
  
)

export default component.exports